import React from 'react';
import { QuestionCircle } from '@lt/components/icons-react';
import styled from 'styled-components';
import type { TravelRequirementsState } from 'src/routes/SearchPage/store/travelRequirements/types';
import { travelRequirementsDTO } from 'src/routes/SearchPage/store/travelRequirements/dto';

type EntryRulesProps = {
  isMobile: boolean;
  travelRequirements: TravelRequirementsState;
  onEntryRulesClick: () => void;
  isWhiteLabel: boolean;
};

export const EntryRules = ({
  isMobile,
  travelRequirements,
  onEntryRulesClick,
  isWhiteLabel,
}: EntryRulesProps): JSX.Element | null => {
  const travelRequirementsData = travelRequirementsDTO(travelRequirements);

  const { title, link } = travelRequirementsData;

  if (!title || !link) {
    return null;
  }

  const handleClick = () => {
    onEntryRulesClick();
    window.open(link, '_blank');
  };

  return !isWhiteLabel ? (
    <Container isMobile={isMobile} onClick={handleClick}>
      <QuestionIcon isMobile={isMobile} />
      <Text>{title}</Text>
    </Container>
  ) : null;
};

const Container = styled.div<{ isMobile: boolean }>`
  color: #007aff;
  display: inline-flex;
  align-items: center;
  font-weight: 400;
  cursor: pointer;
  font-size: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
  line-height: ${({ isMobile }) => (isMobile ? '16px' : '20px')};
`;

const Text = styled.span`
  color: #007aff;
  margin-right: 40px;
`;

const QuestionIcon = styled(QuestionCircle)<{ isMobile: boolean }>`
  height: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
  width: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
  stroke: #007aff;
  margin-right: 4px;
`;
